import { defineMessages } from 'react-intl';

const messages = defineMessages({
  combine: {
    description: 'customerReusableGridButton.combine',
    defaultMessage: 'Combine',
    id: '1/ewL/',
  },
  import: {
    description: 'customerReusableGridButton.import',
    defaultMessage: 'Import',
    id: 'RJdaMI',
  },
  createLabel: {
    description: 'customerReusableGridButton.createLabel',
    defaultMessage: 'Create Label',
    id: 'aUkzrS',
  },
  newOrder: {
    description: 'customerReusableGridButton.newOrder',
    defaultMessage: 'New Order',
    id: 'Y+9UZ5',
  },
  createCustomer: {
    description: 'Create customer button text',
    defaultMessage: 'Create Customer',
    id: 'Q5149N',
  },
  deleteCustomer: {
    description: 'Delete customer button text',
    defaultMessage: 'Delete Customer',
    id: 'dRaBWm',
  },
  editCustomer: {
    description: 'Edit customer button text',
    defaultMessage: 'Edit',
    id: '6woYCg',
  },
});

export default messages;
